import axios from 'axios'
import endpoints from '../configuration/endpoints'
import triggerCustomGaEvent from "../utils/triggerCustomGaEvent";
export const REQUEST_FORM_SUBMISSION = 'REQUEST_FORM_SUBMISSION'
export const FORM_SUBMISSION_SUCCESS = 'FORM_SUBMISSION_SUCCESS'
export const FORM_SUBMISSION_ERROR = 'FORM_SUBMISSION_ERROR'
export const RECEIVE_ALTERNATE_DATE_SELECTION = 'RECEIVE_ALTERNATE_DATE_SELECTION'
export const CLEAR_FORM_ERRORS = 'CLEAR_FORM_ERRORS'

export const submitRFPForm = reqBody => (dispatch, getState) => {
  dispatch({
    type: REQUEST_FORM_SUBMISSION
  })
  triggerCustomGaEvent('requestSailing-sendRequest')

  return axios
    .post(
      endpoints.rfp,
      JSON.stringify({
        createParameters: {
          ...reqBody
        }
      }),
      {
        headers: {
          Accept: 'application/ld+json',
          'Content-Type': 'application/ld+json'
        }
      }
    )
    .then(() => {
      dispatch({
        type: FORM_SUBMISSION_SUCCESS
      })
      triggerCustomGaEvent('requestSailing-sendRequest-success', {
         agencyDetails: getState().agencyDetails,
         sailingDetails: getState().packageDetails.info,
         formDetails: reqBody,
      })
    })
    .catch(err => {
      console.log(err)
      dispatch({
        type: FORM_SUBMISSION_ERROR
      })
      triggerCustomGaEvent('requestSailing-sendRequest-error', true)
    })
}

export const updateAlternateDateSelection = date => dispatch => {
  dispatch({
    type: RECEIVE_ALTERNATE_DATE_SELECTION,
    payload: date,
  })
}

export const clearFormErrors = () => dispatch => {
  dispatch({
    type: CLEAR_FORM_ERRORS,
  })
}